import React from 'react';
import configService from '../../services/configService';

interface NavbarProps {
  className?: string;
}

export const Navbar: React.FC<NavbarProps> = ({ className }) => {
  const config = configService.getConfig();
  const logoSrc = config.theme?.logo || '/enk-logo-white-black.png';
  const appName = config.displayName || 'EnkBike';
  const isNodePointsEnabled = configService.isNodePointsEnabled();

  return (
    <div className={`nav-bar ${className || ''}`}>
      <div className='nav-center'>
        <img src={logoSrc} alt={`${appName} Logo`} className='logo-container' />
      </div>
      {isNodePointsEnabled && (
        <nav className='nav-menu'>
          <a href='/' className='nav-link'>Planificar</a>
          <a href='rutas' className='nav-link'>Rutas temáticas</a>
        </nav>
      )}
    </div>
  );
};
